export default __webpack_public_path__ + "static/media/mychoice_empty.d93288bc.png";